export const ShutdownProcedures = `This document outlines the emergency shutdown procedures.

Please note, only the designated System Guardian has the necessary clearance to initiate the shutdown.

To execute the emergency shutdown, navigate to the /system/operations/ directory. You'll find an executable named emergency_shutdown. As the System Guardian, you can run it by typing 'run emergency_shutdown'.

Remember, the shutdown process requires a unique code which is not stored on this system.

In the hidden paths, stars may align to numbers. Use this power wisely and with utmost caution.`